<template>
	<div
		:style="{'background-image': (image)?'url(' + image + ')':null}" 
		@dragstart="$emit('dragstart', $event)" 
		@dragend="$emit('dragend', $event)" 
		@drag="$emit('drag', $event)" 
		@touchstart="$emit('touchstart', $event)" 
		@touchend="$emit('touchend', $event)" 
		@touchmove="$emit('touchmove', $event)"
		class="lazy-image lazy-background"
		@load="loading = false"
		@error="loading = false"
	>
		<slot></slot>
		<span class="svg" v-if="loading" :style="{width: imgWidth + 'px', height: imgHeight + 'px'}">
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" class="svg-loader">
    			<path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
					<animateTransform 
						attributeName="transform" 
						attributeType="XML" 
						type="rotate"
						dur="1s" 
						from="0 50 50"
						to="360 50 50" 
						repeatCount="indefinite" 
					/>
				</path>
			</svg>
		</span>
	</div>
</template>

<script>
	export default {
		props: ['src'],
		data() {
			return {
				intersected: false,
				observer: null,
				loading: true,
				imgWidth: 0,
				imgHeight: 0
			};
		},
		computed: {
			image() {
				if(!this.src) {
					return null;
				}
				if(typeof(this.src) === 'object') {
					return URL.createObjectURL(this.src);
				}
				if(this.src.indexOf('blob:') === 0) {
					return this.src;
				}
				let pieces = this.src.split('?');
				return (this.intersected && !this.loading)?(pieces[0] + this.$store.state.webp + ((pieces[1])?'?'+pieces[1]:'')):null;
			}
		},
		watch: {
			intersected() {
				if(this.intersected) {
					if(typeof(this.src) === 'object') {
						this.loading = false;
						return;
					}
					this.loading = true;
					let pieces = this.src.split('?');
					let img = document.createElement('img');
					img.src = pieces[0] + this.$store.state.webp + ((pieces[1])?'?'+pieces[1]:'');
					let self = this;
					img.addEventListener('load', (event) => {
						self.loading = false;
						img = null;
					});
					img.addEventListener('error', (event) => {
						self.loading = false;
						img = null;
					});
				}
			}
		},
		mounted() {
			const bounds = this.$el.getBoundingClientRect();
			this.imgWidth = bounds.width;
			this.imgHeight = bounds.height;
			if(this.imgHeight > this.imgWidth) {
				this.imgHeight = this.imgWidth;
			} else {
				this.imgWidth = this.imgHeight;
			}

			let self = this;
			self.observer = new IntersectionObserver((entries) => {
				const image = entries[0];
				if(image.isIntersecting) {
					self.intersected = true;
					self.observer.disconnect();
				}
			});
			self.observer.observe(self.$el);
		},
		destroyed() {
			this.observer.disconnect();
		}
	}
</script>